import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="min-h-screen flex flex-col items-center justify-center px-4"
          style={{ background: "#0c0c14", color: "#e8e8f0" }}
        >
          <h1 className="text-xl font-bold mb-3" style={{ fontFamily: "Orbitron, sans-serif" }}>
            Something went wrong
          </h1>
          <p className="text-sm text-white/60 text-center max-w-md mb-6">
            The app hit an unexpected error. You can try reloading the page.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="px-6 py-3 font-bold text-xs tracking-wider"
            style={{
              fontFamily: "Orbitron, sans-serif",
              background: "#39ff14",
              color: "#0a0a0f",
              border: "none",
              cursor: "pointer",
            }}
          >
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
